import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {PropertyEditModalComponent} from '../property-edit-modal/property-edit-modal.component';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectComponent} from '../../../core/components/edit-component';
import {ClassificatorValuesQuery, PropertyQuery} from 'common-shared';
import {Observable, of} from 'rxjs';
import {map, switchMap, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'mes-web-property-select',
  templateUrl: './property-select.component.html',
  styleUrls: ['./property-select.component.scss'],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class PropertySelectComponent extends SelectComponent<PropertyQuery> implements OnInit, AfterViewInit {
  @Input() favourites: string[] = [];
  @Input() propertyGroups: string[] = [];
  @Input() bindLabel: string = 'DisplayName';
  allFilteredItems$: Observable<any>;
  clonedPropertyGroups: string[] = [];

  constructor(public classificatorValuesQuery: ClassificatorValuesQuery) {
    super();
  }

  ngOnInit() {
    this.clonedPropertyGroups = [...this.propertyGroups];
    this.filterByGroups();
  }

  private filterByGroups() {
    if (this.clonedPropertyGroups.length) {
      this.allFilteredItems$ = this.refreshToken$.pipe(switchMap(() => this.items$ || of(this.items)), map(value => value.filter(p => this.clonedPropertyGroups.indexOf(p.GroupClv) >= 0)), takeUntil(this.componentDestroyed));
    } else {
      this.allFilteredItems$ = this.allItems$;
    }
  }

  addNewProperty(searchTerm: string = null) {
    this.modalService.show(PropertyEditModalComponent, {initialState: {propertyName: searchTerm}}).onHide$.subscribe(bsModalRef => {
      if (bsModalRef.content.propertyId) {
        this.setEntityId(bsModalRef.content.propertyId);
      }
    });
  }

  editProperty() {
    this.modalService.show(PropertyEditModalComponent, {initialState: {propertyId: this.entityId}}).onHide$.subscribe((bsModalRef) => {
      this.setEntityId(bsModalRef.content.propertyId);
    });
  }

  toggleGroupFilter(groupClv: string) {
    if (this.clonedPropertyGroups.includes(groupClv)) {
      this.clonedPropertyGroups = this.clonedPropertyGroups.filter(group => group !== groupClv);
    } else {
      this.clonedPropertyGroups.push(groupClv);
    }
    this.filterByGroups();
  }
}
